// extracted by mini-css-extract-plugin
export default {"container":"j65Z91jRcBT1x_TEZdMD"};